$shm_hitalama_method_runtime_view $mol_book2
	runtime $shm_hitalama_method_runtime
	source? \
	selected? \
	source_method? \
	selected_view? \
	result? \
	fullscreen? false
	method_title* \
	method_view* false
	method_run*? null
	attr *
		^
		shm_hitalama_method_runtime_view_fullscreen <= fullscreen? false
	placeholders /
	pages /
		<= Source_page $mol_page
			title \Исходник
			head /
				<= Template $mol_select
					value? <=> template? \_app
					dictionary <= template_options *
						_app \App
						_ba \BA
				<= Mock $mol_select
					value? <=> mock? \
					dictionary <= mock_options *
			body /
				<= Source $shm_hitalama_textarea
					hint \method source
					sidebar_showed true
					value? <=> source_text? \
					spellcheck false
		<= Methods_page $shm_hitalama_method_runtime_view_methods
			selected? <=> selected? \
			source_method? <=> source_method? \
			ids <= method_ids /
			method_title* <= method_title*
			method_view* <= method_view* false
			run*? <=> method_run*? null
			focus*? <=> method_focus*? false
		<= Preview_page $mol_page
			title <= preview_title \Превью метода
			head /
				<= Preview_fullscreen $mol_check_box
					checked? <=> fullscreen? false
					title \
					field *
						^
						title \Fullscreen
					Icon <= Preview_fullscreen_icon $mol_icon_arrow_expand_all
			body /
				<= Result $mol_view
					sub <= result_sub /
	Result_text $mol_textarea
		value <= result_text \

$shm_hitalama_method_runtime_view_methods $mol_book2_catalog
	menu_title \Методы
	selected? \
	source_method? \
	ids /string
	method_title* \
	method_view* false
	run*? null
	focus*? false
	spread_ids <= ids
	spread_title* <= method_title*
	menu_filter_enabled false
	placeholders /
	menu_item_content* /$mol_view
		<= Method_item*
	Method_item* $shm_hitalama_method_runtime_view_methods_item
		method_view <= method_view* false
		sub /
			<= Method_focus*
			<= Menu_link*
	Method_focus* $mol_check_box
		checked? <=> focus*? false
		title \
	Menu_link* $shm_hitalama_method_runtime_view_methods_link
		attr *
			^
			mol_link_current <= item_current* false
		arg *
		sub <= menu_link_content* /$mol_view_content
			<= Method_title* $mol_dimmer
				needle <= menu_filter
				haystack <= method_title*
		click? <=> run*? null
	item_current* false

$shm_hitalama_method_runtime_view_methods_link $mol_link

$shm_hitalama_method_runtime_view_methods_item $mol_view
	method_view false
	attr *
		^
		shm_hitalama_method_runtime_view_method_view <= method_view false
